// import React from 'react';
// import './Gallery.css';

// const Gallery = () => {
//   return (
//      <>
//       <div className="container-fluid" id='gallery'>
//         <div className="row">
//             <div className="col col-3">
//                <img src="img-data/gallery/img-1.jpg" alt="..." style={{width:"80vw"}} />
//                {/* <h1>img-1</h1> */}
//                <hr />
//                <div>Our Director <b>Mr. Dharmendra Pandey</b> is with <b>Mr.Mahendra Nath Pandey</b> Minister of Heavy Industries he previously served as Minister for Skill Development and Entrepreneurship of India </div>
//                <hr />
//             </div>
//             <div className="col col-3">
//             <img src="img-data/gallery/img-2.jpg" alt="..." style={{width:"80vw"}} />
//             <hr />
//             <div>Our Director <b> Mr. Dharmendra Pandey </b> at <b>"Udyog Ratan Award 2023 "</b> Organized By <b>"Jagran"</b>.</div>
//             <hr />
//             </div>
//             <div className="col col-3">
//             <img src="img-data/gallery/img-3.jpg" alt="..." style={{width:"80vw"}} />
//             <hr />
//             <div>Our Director <b> Mr. Dharmendra Pandey </b>is with our team at <b>"Udyog Ratan Award 2023 "</b> Organized By <b>"Jagran"</b>.</div>
//             <hr />
//             </div>
//             <div className="col col-3">
//             <img src="img-data/gallery/img-4.jpg" alt="..." style={{width:"80vw"}} />
//             <hr />
//             <div>In <b>"Udyog Ratan Award 2023"</b> organized by <b>"Jagran"</b> our Director <b>Mr. Dharmendra Pandey</b> giving a speech on the struggles and success of his <b>"Unique Technologies"</b>.</div>
//             <hr />
//             </div>

//             <div className="col col-3">
//             <img src="img-data/gallery/img-5.jpg" alt="..." style={{width:"80vw"}} />
//             <hr />
//             <div>
//                Our Team <b>"Unique Technologies"</b> awarded  by <b>"Jagran"</b> from <b>"Udyag Ratan 2023"</b>.
//              </div>
//              <hr />
//             </div>

//             <div className="col col-3">
//             <img src="img-data/gallery/img-6.jpg" alt="..." style={{width:"40vw"}} />
//             <hr />
//             <div>
//                Our Team <b>"Unique Technologies"</b> awarded  by <b>"Jagran"</b> from <b>"Udyag Ratan 2023"</b>.
//              </div>
//              <hr />
//             </div>
//         </div>
//       </div>
//      </>
//   )
// }

// export default Gallery

import React, { useEffect } from 'react';
import './Gallery.css';
import AOS from 'aos';

const Gallery = () => {
  useEffect(() => {
    AOS.init();
      window.scrollTo(0, 0)
  }, [])
  return (
   <>
    <div className="container-fluid" id='gallery'>
    <div className="msme-heading">
        INDIA 5000 BEST MSME AWARDS
      </div>
     <div className="video-container">
     <iframe 
        width="680" 
        height="415" 
        src="https://www.youtube.com/embed/obKKs0gJJ3M?si=_K2tr3odTv7RL2k2" 
        title="YouTube Video" 
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
        allowFullScreen
      ></iframe>
     </div>
      <div className="msme-heading">
        INDIA 5000 BEST MSME AWARDS
      </div>
     <div className="video-container">
     <video id="msme-video" className='responsive-video'  controls  autoPlay muted preload="auto" loop>
        <source src="/msme-award.mp4"   type="video/mp4" />
        Your browser does not support the video tag.
      </video>
     </div>
     
      <div className="row">
        <div className="col left-col"><img src="img-data/gallery/image-1.png" alt="" data-aos="fade-right" data-aos-offset="0"  data-aos-duration="1000" /></div>
        <div className="col right-col text-col" data-aos="fade-left" data-aos-offset="0"  data-aos-duration="1000">
        Our Director <b>Mr. Dharmendra Pandey</b> is with <b>Mr.Mahendra Nath Pandey</b> Minister of Heavy Industries he previously served as Minister for Skill Development and Entrepreneurship of India 
        </div>
      </div>
      <hr />
      <div className="row">
      <div className="col right-col text-col" data-aos="fade-right" data-aos-offset="300"  data-aos-duration="1000">
      Our Director <b> Mr. Dharmendra Pandey </b> at <b>"Udyog Ratan Award 2023 "</b> Organized By <b>"Jagran"</b>.
        </div>
        <div className="col left-col"><img src="img-data/gallery/image-2.png" alt="" data-aos="fade-left" data-aos-offset="300"  data-aos-duration="1000" /></div>
        
      </div>
      <hr />
      <div className="row">
        <div className="col left-col"><img src="img-data/gallery/image-3.png" alt="" data-aos="fade-right" data-aos-offset="300"  data-aos-duration="1000" /></div>
        <div className="col right-col text-col" data-aos="fade-left" data-aos-offset="300"  data-aos-duration="1000">
        Our Director <b> Mr. Dharmendra Pandey </b>is with our team at <b>"Udyog Ratan Award 2023 "</b> Organized By <b>"Jagran"</b>.
        </div>
      </div>
      <hr />
      <div className="row">
      <div className="col right-col text-col" data-aos="fade-right" data-aos-offset="300"  data-aos-duration="1000">
      In <b>"Udyog Ratan Award 2023"</b> organized by <b>"Jagran"</b> our Director <b>Mr. Dharmendra Pandey</b> giving a speech on the struggles and success of his <b>"Unique Technologies"</b>.
        </div>
        <div className="col left-col"><img src="img-data/gallery/image-4.png" alt="" data-aos="fade-left" data-aos-offset="300"  data-aos-duration="1000" /></div>
        
      </div>
      <hr />
      <div className="row">
        <div className="col left-col" ><img src="img-data/gallery/image-5.png" alt="" data-aos="fade-right" data-aos-offset="300"  data-aos-duration="1000" /></div>
        <div className="col right-col text-col" data-aos="fade-left" data-aos-offset="300"  data-aos-duration="1000">
        Our Team <b>"Unique Technologies"</b> awarded  by <b>"Jagran"</b> with <b>"Udyag Ratan 2023"</b>
        </div>
      </div>
      <hr />
      <div className="row">
      <div className="col right-col text-col" data-aos="fade-right" data-aos-offset="300"  data-aos-duration="1000">
      Our Team <b>"Unique Technologies"</b> awarded  by <b>"Jagran"</b> from <b>"Udyag Ratan 2023"</b>.
        </div>
        <div className="col left-col"><img src="img-data/gallery/image-6.png" alt="" data-aos="fade-left" data-aos-offset="300"  data-aos-duration="1000" /></div>
        
      </div>
    </div>
   </>
  )
}

export default Gallery
